import type { TokenInfo } from "@src/components/DefuseSDK/types/base"
import { isBaseToken } from "@src/components/DefuseSDK/utils/token"
import { CURATED_EARN_VAULTS } from "@src/shared/constants/earnVaults"

export const EARN_VAULT_TAG = "category:earn-vault"

export function isEarnVaultToken(token: TokenInfo | null | undefined): boolean {
  return token?.tags?.includes(EARN_VAULT_TAG) ?? false
}

export function getEarnVaultUsdUnitSymbol(
  token: TokenInfo | null | undefined
): "USDC" | undefined {
  if (token == null || !isBaseToken(token) || !isEarnVaultToken(token)) {
    return undefined
  }
  const definition = CURATED_EARN_VAULTS.find(
    (entry) => entry.tokenSymbol === token.symbol
  )
  if (definition == null) return undefined
  return definition.baseUnifiedAssetId === "usdc" ? "USDC" : undefined
}

export type EarnVaultOperation = "deposit" | "withdraw"

export function classifyEarnVaultOperation(
  fromToken: TokenInfo | null | undefined,
  toToken: TokenInfo | null | undefined
): EarnVaultOperation | null {
  const fromVault = isEarnVaultToken(fromToken)
  const toVault = isEarnVaultToken(toToken)
  if (toVault && !fromVault) return "deposit"
  if (fromVault && !toVault) return "withdraw"
  return null
}
